import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
var IconCaution = function IconCaution(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.916,11.11,7.5.285a.577.577,0,0,0-1,0L.083,11.11a.588.588,0,0,0,.5.89H13.418A.588.588,0,0,0,13.916,11.11Zm-6.045-.531H6.128V8.816H7.871Zm0-2.939H6.128v-4.7H7.871Z",
      transform: "translate(0 0)",
      fill: "#eb7d3c"
    })
  }));
};
IconCaution.defaultProps = {
  viewBox: "0 0 14 12"
};
import styles from "@/styles/Form.module.scss";
import modalStyles from "@/styles/Modal.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ErrorMessage(_ref) {
  let {
    msg,
    inModal,
    processHeadingCaution
  } = _ref;
  if (!msg) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!inModal && !processHeadingCaution && /*#__PURE__*/_jsxs("span", {
      className: styles.errorMessage,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.iconCaution,
        children: /*#__PURE__*/_jsx(IconCaution, {})
      }), msg]
    }), inModal && /*#__PURE__*/_jsxs("h4", {
      className: modalStyles.errorMessageHeading,
      children: [/*#__PURE__*/_jsx("span", {
        className: modalStyles.iconCaution,
        children: /*#__PURE__*/_jsx(IconCaution, {})
      }), msg]
    }), processHeadingCaution && /*#__PURE__*/_jsxs("p", {
      className: processStyles.processHeadingCaution,
      children: [/*#__PURE__*/_jsx("span", {
        className: processStyles.iconCaution,
        children: /*#__PURE__*/_jsx(IconCaution, {})
      }), msg]
    })]
  });
}